import { useEffect, useState } from 'react';
import { getDahsInfo } from '../../apis/serviceDashboard';
import ReactLoading from 'react-loading';
import { getFromSessionStorage, removeItemSessionStorage } from '../../../../contexts/LocalStorage';
import { Toast } from '../../../../themes/components/Toast';
import { useHistory } from 'react-router-dom';
import { VictoryAxis, VictoryBar, VictoryChart, VictoryGroup, VictoryLegend, VictoryTheme, VictoryTooltip } from 'victory';
import { formatter } from '../../../../util/fieldMasks';
import { TitleChart } from '../TitleCharts';

interface dadosDash {
    "data": string,
    "tipo": string,
    "valor": string | number,
    "ano": string,
    "empresa": string
}

export const ChartFaturamento = (props: any) => {
    const history = useHistory();
    const typeDash = "DASH01";
    const dadosEmpty = {
        "data": "",
        "tipo": "",
        "valor": "",
        "ano": "",
        "empresa": ""
    }
    const months = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
    const [dadosGraph, setDadosGraph] = useState<[dadosDash]>([dadosEmpty]);
    const [dadosGraph2, setDadosGraph2] = useState<[dadosDash]>([dadosEmpty]);
    const [loading, setLoading] = useState<boolean>(true);
    const [maxValor, setMaxValor] = useState<number>(0);
    const cor1 = "rgb(255, 205, 98)";
    const cor2 = "rgb(10, 102, 240)";
    const strokeColor = "#acacac";
    const [dadosGraphFiltered, setDadosGraphFiltered] = useState<[dadosDash]>([dadosEmpty]);
    const [dadosGraph2Filtered, setDadosGraph2Filtered] = useState<[dadosDash]>([dadosEmpty]);

    //Carregando os valores para informar no Dash ao entrar na tela
    useEffect(() => {
        getDahsInfo(typeDash, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
            .then((res: [dadosDash] | dadosDash) => {
                if (res instanceof Array) {
                } else {
                    res = [res];
                }
                let temp: any = [];
                let temp2: any = [];
                let tempMaxValor = 0;
                let tempValor = 0;
                let ano1 = res[0].data.substring(3, 7);
                res.forEach((element: any) => {                 
                    tempValor = parseFloat(element.valor);
                    if (tempValor > tempMaxValor) {
                        tempMaxValor = tempValor
                    }
                    if (element.data.substring(3, 7) === ano1) {
                        temp.push({
                            "data": months[parseInt(element.data.substring(0, 2)) - 1],
                            "tipo": element.tipo,
                            "valor": tempValor,
                            "ano": element.data.substring(3, 7),
                            "empresa": element.empresa
                        });
                    } else {
                        temp2.push({
                            "data": months[parseInt(element.data.substring(0, 2)) - 1],
                            "tipo": element.tipo,
                            "valor": tempValor,
                            "ano": element.data.substring(3, 7),
                            "empresa": element.empresa
                        });
                    }
                });
                setMaxValor(tempMaxValor);
                setDadosGraph(temp);
                setDadosGraph2(temp2);

            })
            .catch(err => {
                if (err.error.message !== undefined) {
                    if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                        redirectTo(history, '/login', { from: history.location.pathname });
                    } else if (err.error.message.includes("Network Error")) {
                        Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                    }
                } else {
                    Toast("error", "Falha ao consultar informações do Dashboard: " + typeDash);
                }
            })
            .finally(() => {
                setLoading(false);
            })

    }, [])

    function redirectTo(history: any, pathname: string, state: { from: string }) {
        if (pathname === "/login") {
            removeItemSessionStorage("logid");
        }
        history.push({
            pathname: process.env.PUBLIC_URL + pathname,
            state: state
        })
    }

    useEffect(() => {
        let temp: any = [];
        let temp2: any = [];

        dadosGraph.filter((row: any) => {
            if (row.empresa == props.estoque) {
                temp.push(row);
            }
        });

        dadosGraph2.filter((row: any) => {
            if ((row.empresa == props.estoque)) {
                temp2.push(row);
            }
        });
        setDadosGraphFiltered(temp);
        setDadosGraph2Filtered(temp2);
    }, [props.estoque, dadosGraph2, dadosGraph, loading]);

    return (
        <div className='container-chart-dashboard'>
            {loading ?
                <ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} className="detalhe-pedido-titulo-loading" />
                :
                <div className='chart1'>
                    <TitleChart text={`Faturamento ${dadosGraphFiltered[0]?.ano ? dadosGraphFiltered[0].ano : "2000"} x ${dadosGraph2Filtered[0]?.ano ? dadosGraph2Filtered[0].ano : "2000"}`} />
                    <VictoryChart
                        theme={VictoryTheme.material}
                        domainPadding={10}
                        width={1100}
                        domain={{ x: [0.7, dadosGraphFiltered.length], y: [0, Math.round(maxValor) * 1.12] }}
                        padding={{ left: 110, top: 50, right: 40, bottom: 40 }}
                    >
                        <VictoryLegend
                            x={900} y={0}
                            title="Valor Faturado"
                            orientation="horizontal"
                            centerTitle
                            gutter={15}
                            style={{
                                labels: { fontSize: 10 },
                                border: { stroke: strokeColor },
                            }}
                            data={[
                                { name: dadosGraphFiltered[0]?.ano ? dadosGraphFiltered[0].ano : "2000", symbol: { fill: cor1, type: "square" } }, { name: dadosGraph2Filtered[0]?.ano ? dadosGraph2Filtered[0].ano : "2000", symbol: { fill: cor2, type: "square" } }
                            ]}
                        />
                        {dadosGraphFiltered[0]?.ano && dadosGraph2Filtered[0]?.ano ?
                            <VictoryGroup offset={26}
                                theme={VictoryTheme.material}>
                                <VictoryBar
                                    style={{ data: { fill: cor1 } }}
                                    data={dadosGraphFiltered}
                                    x={"data"}
                                    y={"valor"}
                                    animate={{
                                        duration: 2000,
                                        onLoad: { duration: 1000 }
                                    }}
                                    barWidth={23}
                                    labels={({ datum }) => formatter.format(datum.valor)}
                                    labelComponent={<VictoryTooltip
                                        flyoutStyle={{ stroke: strokeColor, strokeWidth: 1 }}
                                    />}
                                />
                                <VictoryBar
                                    style={{ data: { fill: cor2 } }}
                                    data={dadosGraph2Filtered}
                                    x={"data"}
                                    y={"valor"}
                                    animate={{
                                        duration: 2000,
                                        onLoad: { duration: 1000 }
                                    }}
                                    barWidth={23}
                                    labels={({ datum }) => formatter.format(datum.valor)}
                                    labelComponent={<VictoryTooltip
                                        flyoutStyle={{ stroke: strokeColor, strokeWidth: 1 }}
                                    />}
                                />
                            </VictoryGroup>
                            :
                            <></>
                        }
                        <VictoryAxis
                            orientation='bottom'
                            tickValues={months}
                            style={{
                                axis: { stroke: strokeColor },
                                grid: { stroke: "transparent" },
                            }}
                        />
                        <VictoryAxis dependentAxis
                            orientation='left'
                            offsetX={110}
                            tickFormat={(y: any) => formatter.format(y)}
                            style={{
                                grid: { stroke: strokeColor, strokeDasharray: "1, 0", strokeWidth: 0.2 },
                                ticks: { stroke: strokeColor, strokeDasharray: "1, 0", strokeWidth: 0.2 }
                            }}
                        />
                    </VictoryChart>
                </div>
            }
        </div>
    )
}